// Filter groups for different user types
export const FILTER_GROUPS = {
  FOUNDER: {
    KEY_DETAILS: {
      Cost: "Cost",
      Location: "Location",
      "Web and Social Presence": "Web and Social Presence"
    }
  },
  VENDOR: {
    KEY_DETAILS: {
      "Service Type": "Service Type",
      Experience: "Experience",
      Portfolio: "Portfolio"
    }
  }
};

/**
 * Filters user answers based on the user type and specific filter
 * @param {Array} userAnswers - Array of user answers
 * @param {string} userType - Either 'FOUNDER' or 'VENDOR'
 * @param {string} filter - The specific filter to apply
 * @returns {Array} Filtered user answers
 */
export const filterUserAnswers = (userAnswers, userType, filter) => {
  if (!userAnswers || !userType || !filter) return [];
  
  const filterGroups = FILTER_GROUPS[userType];
  if (!filterGroups || !filterGroups.KEY_DETAILS[filter]) return [];

  return userAnswers.filter(ua => 
    ua.question.group === filterGroups.KEY_DETAILS[filter]
  );
};

/**
 * Gets all available filters for a user type
 * @param {string} userType - Either 'FOUNDER' or 'VENDOR'
 * @returns {Object} Object containing all available filters
 */
export const getAvailableFilters = (userType) => {
  if (!userType || !FILTER_GROUPS[userType]) return {};
  return FILTER_GROUPS[userType].KEY_DETAILS;
};

/**
 * Groups user answers by their question groups
 * @param {Array} userAnswers - Array of user answers
 * @param {string} userType - Either 'FOUNDER' or 'VENDOR'
 * @returns {Object} Grouped user answers
 */
export const groupUserAnswers = (userAnswers, userType) => {
  if (!userAnswers || !userType) return {};

  const groups = FILTER_GROUPS[userType];
  if (!groups) return {};

  return Object.keys(groups).reduce((acc, groupKey) => {
    acc[groupKey] = filterUserAnswers(userAnswers, userType, groupKey);
    return acc;
  }, {});
}; 